<template>
  <div class="counter">
    <Icon
      name="minus"
      theme="circle"
      size="xs"
      :fn="
        () =>
          data.fn && !data.readonly
            ? data.fn([data.itemKey, computedValue - 1])
            : false
      "
    />
    <input
      :id="
        formId ? `${formId}-${data.id || $vnode.key}` : data.id || $vnode.key
      "
      v-model.trim="computedValue"
      :data-key="data.itemKey"
      :name="data.id || $vnode.key"
      type="number"
      :placeholder="data.placeholder"
      :readonly="data.readonly"
      size="1"
      @change="data.fn ? data.fn($event) : false"
    >
    <Icon
      name="plus"
      theme="circle"
      size="xs"
      :fn="
        () =>
          data.fn && !data.readonly
            ? data.fn([data.itemKey, computedValue + 1])
            : false
      "
    />
  </div>
</template>

<script>
import Icon from '@/components/ui/icon';

export default {
  name: 'Counter',
  components: {
    Icon,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    formId: {
      type: String,
      default: () => {},
    },
  },
  computed: {
    computedValue: {
      get() {
        return Number(this.value);
      },
      set(val) {
        this.$emit('update:value', Number(val));
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss">
  .counter {
    align-items: center;
    border-radius: var(--border-radius);
    border: var(--line) var(--yellow) solid;
    color: var(--yellow);
    display: grid;
    grid-auto-flow: column;
    height: var(--cta-height);
    justify-content: space-between;
    min-width: 180px;

    input {
      text-align: center;
    }

    .icon-minus {
      margin-left: var(--spacer-s);
    }
    .icon-plus {
      margin-right: var(--spacer-s);
    }
  }
</style>
